import { render, staticRenderFns } from "./PrizeName.vue?vue&type=template&id=087dfb7a&"
import script from "./PrizeName.vue?vue&type=script&lang=js&"
export * from "./PrizeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports